// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo_B132t","navBar":"Header_navBar_2E5aP","as":"Header_as_3jjjI","mavItem":"Header_mavItem_1jDlJ","heighLight":"Header_heighLight_3sAEr"};